import { useTranslation } from "react-i18next";

import { TableHeader } from "@/components/Layout/Table/TableHeader/TableHeader";
import { TableSortButton } from "@/components/Layout/Table/TableSortButton/TableSortButton";
import { GetEvnForCustomerSortField } from "@/services/model";

import { EvnSelectAllCheckbox } from "./EvnSelectAllCheckbox";

// this is the table header row for the itemized bill (EVN) overview
export const ItemizedBillOverviewHeader = ({
  currentPageItemizedBillIds,
  isSelecting,
}: {
  currentPageItemizedBillIds: string[];
  isSelecting?: boolean;
}) => {
  const { t } = useTranslation("portal");

  return (
    <TableHeader>
      {/* Unlike the bills table, the checkbox column is added ahead of the
          data columns rather than swapped - both are visible at once while
          selecting. */}
      {isSelecting && (
        <th className="evn-selection">
          <EvnSelectAllCheckbox
            currentPageItemizedBillIds={currentPageItemizedBillIds}
          />
        </th>
      )}
      <th>{t("bills.list.tableHeaders.plan")}</th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.period")}
          sortField={GetEvnForCustomerSortField.Datum}
        />
      </th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.amount")}
          sortField={GetEvnForCustomerSortField.Betrag}
        />
      </th>
      <th>{t("bills.list.tableHeaders.number")}</th>
      <th>{t("bills.list.tableHeaders.open")}</th>
    </TableHeader>
  );
};
